import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { Role } from '@app/features/scoping/models/role.model'
import { RoleChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/role-with-changes.interface'

export function getRoleChanges(
  role: Role,
  previewRole: Role,
  component: ScopeComponent,
  previewComponent: ScopeComponent
): RoleChanges {
  return {
    rateCardTotalHours: {
      old: role?.getRateCardHours(),
      new: previewRole?.getRateCardHours(),
    },
    agencyPrice: {
      old: role?.getUserSellingPrice({ markup: component.costPlusValue })?.amount,
      new: previewRole?.getUserSellingPrice({ markup: previewComponent?.costPlusValue })?.amount,
    },
  }
}
